import { Fragment } from "react";
import { Button, Checkbox, FormControlLabel, FormGroup, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useBillingAddress } from "./hooks/useBillingAddress";
import { Address } from "@common/Eircode/Address";
import { IUserAddress } from "@common/Eircode/interface/IAddressForm";
import { Loader } from "@common/Loader/Loader";

interface IParams {
    billingAddress?: IUserAddress;
    getUserAddress(): void;
}

export const BillingAddressForm = (props: IParams) => {
    const { billingAddress, getUserAddress } = props;
    const { t } = useTranslation(["profile", "glossary", "common"]);

    const {
        submitUserAddress,
        formMethods,
        editing: { isEditing, setIsEditing },
        sameAddress: { hasSameDeliveryAddress, setHasSameDeliveryAddress },
        updateUserAddressState,
    } = useBillingAddress(billingAddress);

    const cancel = () => {
        setIsEditing(false);
        getUserAddress();
    };

    return (
        <form onSubmit={submitUserAddress}>
            <FormGroup row>
                <Address
                    addressForm={formMethods}
                    buttonColor="secondary"
                    eirCodeLogoColor="blue"
                    isEditing={isEditing}
                    isUpdated={updateUserAddressState.isLoading}
                />
            </FormGroup>
            {isEditing && (
                <Fragment>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={hasSameDeliveryAddress}
                                color="secondary"
                                onChange={() => setHasSameDeliveryAddress(!hasSameDeliveryAddress)}
                            />
                        }
                        disabled={updateUserAddressState.isLoading}
                        label={t("profile:deliverySameAs")}
                    />
                    {updateUserAddressState.error && (
                        <Typography color="error" variant="small">
                            {t("common:genericError")}
                        </Typography>
                    )}
                    <Grid className="profileBilling__buttons" container>
                        {!updateUserAddressState.isLoading && (
                            <Fragment>
                                <Grid item sm={2} xs={4}>
                                    <Button
                                        color="secondary"
                                        fullWidth
                                        size="large"
                                        type="button"
                                        variant="outlined"
                                        onClick={cancel}
                                    >
                                        {t("common:cancel")}
                                    </Button>
                                </Grid>
                                <Grid item sm={2} xs={4}>
                                    <Button color="secondary" fullWidth size="large" type="submit" variant="contained">
                                        {t("glossary:save")}
                                    </Button>
                                </Grid>
                            </Fragment>
                        )}
                        {updateUserAddressState.isLoading && (
                            <Grid item sm={2} xs={4}>
                                <Loader size={40} />
                            </Grid>
                        )}
                    </Grid>
                </Fragment>
            )}
            {!isEditing && (
                <Grid className="profileBilling-edit__button" container>
                    <Grid item sm={2} xs={4}>
                        <Button
                            color="secondary"
                            fullWidth
                            size="large"
                            variant="contained"
                            onClick={() => setIsEditing(true)}
                        >
                            {t("profile:edit")}
                        </Button>
                    </Grid>
                </Grid>
            )}
        </form>
    );
};
